import { IProjectInvitationGet } from "../../../../../../service/invitationLinks/IProjectInvitationGet";

export const removeHTTPProtocol = (url: string): string => {
  return url.replace(/^https?:\/\//, '');
}
export const getInvitationLink = ({ address }: IProjectInvitationGet) => {
    return `${window.location.origin}/i${address}`
}

export const areArraysEqual = (array1, array2) => {
    const set1 = new Set(array1);
    const set2 = new Set(array2);

    if (set1.size !== set2.size) {
      return false;
    }

    for (let item of set1) {
      if (!set2.has(item)) {
        return false;
      }
    }

    return true;
  }

  export const lowercaseRoleFirst = (str: string) => {
    if(['DevOps', 'QA engineer'].includes(str)) {
      return str
    }

    if (!str) return str;

    return str.charAt(0).toLowerCase() + str.slice(1);
  }
